<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <div class="content inner-scroll" style="overflow: auto; -webkit-overflow-scrolling: touch; width: 230px;">


        <div class="nav material2">
            <div class="col-md-4">

            </div>
        </div>

    </div>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center" style="margin-left: 5px;">

        <div class="content-card scroll-container" style="overflow: auto; -webkit-overflow-scrolling: touch;" #scrollContainer>

            <div class="row">

                <div class="col-md-6 text-left">
                    <div *ngIf="processing"> {{'Processing'|translate}}... </div>
                    <div *ngIf="error.length>0" style="color:red;">{{error}}</div>

                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
                        <mat-button-toggle
                                mwlCalendarPreviousView
                                [view]="view"
                                [(viewDate)]="viewDate"
                                (viewDateChange)="closeOpenMonthViewDay()"
                        >
                            {{'Previous week'|translate}}</mat-button-toggle>
                        <mat-button-toggle
                                mwlCalendarToday
                                [(viewDate)]="viewDate"
                        >
                            {{'Current week' | translate}}
                        </mat-button-toggle>
                        <mat-button-toggle
                                mwlCalendarNextView
                                [view]="view"
                                [(viewDate)]="viewDate"
                                (viewDateChange)="closeOpenMonthViewDay()"
                        >
                            {{'Next week'|translate}}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="col-md-6 text-right">
                    <h3>{{ viewDate | calendarDate:('dayViewTitle'):locale }}</h3>
                </div>
            </div>

            <ng-template
                #currentTimeMarkerTemplate
                let-columnDate="columnDate"
                let-dayStartHour="dayStartHour"
                let-dayStartMinute="dayStartMinute"
                let-dayEndHour="dayEndHour"
                let-dayEndMinute="dayEndMinute"
                let-isVisible="isVisible"
                let-topPx="topPx"
            >
                <div
                        class="cal-current-time-marker"
                        *ngIf="isVisible && showMarker"
                        [style.top.px]="topPx"
                ></div>
            </ng-template>

            <week-view-scheduler
                    [viewDate]="viewDate"
                    [events]="events"
                    [users]="users"
                    [locale]="locale"
                    (hourSegmentClicked)="sectionClicked($event)"
                    (eventClicked)="eventClicked($event)"
                    [currentTimeMarkerTemplate]="currentTimeMarkerTemplate"
                    [hourSegments]="1"
            >
            </week-view-scheduler>
        </div>

    </div>
</div>
